// 账户管家
const getToolsAccountStewardParams = (query = '') => {
    const params = new URLSearchParams(query ?? '');
    let uid = '';
    for (const item of params) {
        if (item[0] === 'spreaderId') {
            uid = parseInt(item[1]);
            break;
        }
    }
    return {
        uid,
    };
};

export { getToolsAccountStewardParams };
